export default __webpack_public_path__ + "static/media/rafa5.4b0240d0.jpg";